// Color palette — aligned with Vera Web + App visual language
export const COLOR_CANVAS = '#F2F0EB';
export const COLOR_SURFACE = '#FFFEFB';
export const COLOR_PRIMARY = '#001B5E';
export const COLOR_PRIMARY_100 = '#D9E4F5';
export const COLOR_PRIMARY_300 = '#8FA3C8';
export const COLOR_PRIMARY_900 = '#001447';
export const COLOR_SECONDARY = '#F19E7A';
export const COLOR_SECONDARY_50 = '#FFFEFB';
export const COLOR_SECONDARY_200 = '#EBE9E1';
export const COLOR_DANGER = '#D8273E';
export const COLOR_SUCCESS = '#8AC285';

export const DURATIONS_MS = {
  MINUTE: 60 * 1000,
  FIVE_MINUTES: 5 * 60 * 1000,
  FIFTEEN_MINUTES: 15 * 60 * 1000,
  THIRTY_MINUTES: 30 * 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
  ONE_DAY: 24 * 60 * 60 * 1000,
  ONE_WEEK: 7 * 24 * 60 * 60 * 1000,
  ONE_MONTH: 30 * 24 * 60 * 60 * 1000,
  ONE_YEAR: 365 * 24 * 60 * 60 * 1000,
};

export const stripeAppearance = {
  theme: 'flat',

  variables: {
    colorPrimary: COLOR_PRIMARY_900,
    colorBackground: COLOR_SECONDARY_200,
    colorText: COLOR_PRIMARY_900,
    colorDanger: COLOR_SECONDARY,
  },
};

export const API_URL =
  process.env.REACT_APP_API_URL ??
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:3500'
    : 'https://veraconnect.app/api');

export const CONSUMER_URL = process.env.REACT_APP_CONSUMER_URL || 'https://localhost:3333';
export const COMMUNITY_URL = process.env.REACT_APP_COMMUNITY_URL || 'https://veracommunity.app';
export const BUSINESS_URL = process.env.REACT_APP_BUSINESS_URL || 'https://verabusiness.app';

export const GOOGLE_PLACES_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY || '';

export const MAXIMUM_COMMUNITIES_PER_ASSOCIATION = 20;

export const ALLOWED_FINANCIAL_COMMUNITY_IDS: number[] = [422, 319, 86, 237, 417];
